export function Spinner() {
  return (
    <div className=" 
      h-8 
      w-8 
      border-4 
      border-l-gray-100 
      border-r-gray-100 
      border-b-gray-100
      border-t-primary
      animate-spin
      ease-linear
      rounded-full
    " />
  );
}